module.exports = __webpack_public_path__ + "static/media/room-3.9a1103b5.jpeg";